import {makeAutoObservable, observable} from 'mobx'
import {Debouncer} from 'yougile-util'

const triggerDebouncer = new Debouncer(1000)

export class TaskPhantomObserver {
  state = {
    modified: 0
  }

  constructor() {
    makeAutoObservable(
      this,
      {
        state: observable.shallow
      },
      {
        autoBind: true
      }
    )
  }

  update(): void {
    this.state.modified = Date.now()
  }

  updateWithDebounce(): void {
    triggerDebouncer.runLatest(() => {
      this.update()
    })
  }

  get modified(): number {
    return this.state.modified
  }
}

const taskPhantomObserver = new TaskPhantomObserver()

export {taskPhantomObserver}
